<template>
  <div class="container">
    <h1>Configure</h1>
    <b-tabs>
      <b-tab-item label="Data Sources">
        <div class="tab-content">
          <div class="level">
            <div class="level-left">
              <div class="level-item" v-if="hasConfigurePermission(22)">
                <router-link :to="{path: '/configure/integrations'}">Integrations</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(18)">
                <router-link :to="{path: '/configure/devices'}">Devices</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(13)">
                <router-link :to="{path: '/configure/objects'}">Objects</router-link>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Organize">
        <div class="tab-content">
          <div class="level">
            <div class="level-left">
              <div class="level-item" v-if="hasConfigurePermission(21)">
                <router-link :to="{path: '/configure/groups'}">Groups</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(25)">
                <router-link :to="{path: '/configure/boards'}">Boards</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(15)">
                <router-link :to="{path: '/configure/cameras'}">Cameras</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(17)">
                <router-link :to="{path: '/configure/rooms'}">Rooms</router-link>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Advanced">
        <div class="tab-content">
          <div class="level">
            <div class="level-left">
              <div class="level-item" v-if="hasConfigurePermission(28)">
                <router-link :to="{path: '/configure/mqtt'}">MQTT local access</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(32)">
                <router-link :to="{path: '/configure/notifications'}">Notifications</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(36)">
                <router-link :to="{path: '/configure/pd'}">Presence Detectors</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(19)">
                <router-link :to="{path: '/debug/topics'}">Debug Topics</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(29)">
                <router-link :to="{path: '/flags'}">Engine Flags</router-link>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
      <b-tab-item label="Engine Operations">
        <div class="tab-content">
          <div class="level">
            <div class="level-left">
              <div class="level-item" v-if="hasConfigurePermission(23)">
                <b-button type="is-danger-outlined" class="is-small" :disabled="isDisabled()" @click="handleBackup">
                  Backup configuration
                </b-button>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(23)">
                <b-button type="is-danger-outlined" class="is-small" :disabled="isDisabled()" @click="handleBackupData">
                  Backup data
                </b-button>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(26)">
                <router-link :to="{path: '/configure/restore'}">Restore</router-link>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(20)">
                <b-button type="is-danger-outlined" class="is-small" :disabled="isDisabled()" @click="handleRestart">
                  Restart Engine
                </b-button>
              </div>
              <div class="level-item" v-if="hasConfigurePermission(24) && 3 > 5">
                <b-button type="is-danger" class="is-small" :disabled="isDisabled()" @click="handleReset">Reset All
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BButton from "buefy/src/components/button/Button";
  import BTabs from "buefy/src/components/tabs/Tabs";
  import BTabItem from "buefy/src/components/tabs/TabItem";

  export default {
    name: "screenconfigure",
    components: {
      BTabItem,
      BTabs,
      BButton
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters('ui', ['loadingOverlay']),
      ...mapGetters('auth', ['hasPermission', 'restarting'])
    },
    methods: {
      ...mapActions('auth', ['postRestart', 'postBackup', 'postReset', 'postBackupEventsData']),
      hasConfigurePermission(permissionId) {
        return this.hasPermission(permissionId);
      },
      isDisabled() {
        return this.restarting;
      },
      handleRestart() {
        if (confirm('Are you sure you want to restart ?')) {
          this.postRestart();
        }
      },
      handleBackup() {
        if (confirm('Are you sure ?')) {
          if (process.env.NODE_ENV === "development") {
            if (confirm('You are on a development environment. It might NOT be such a good idea to make a backup.')) {
              this.postBackup();
            }
          } else {
            this.postBackup();
          }
        }
      },
      handleBackupData() {
        if (confirm('Are you sure ?')) {
          if (process.env.NODE_ENV === "development") {
            if (confirm('You are on a development environment. It might NOT be such a good idea to make a backup.')) {
              this.postBackupEventsData();
            }
          } else {
            this.postBackupEventsData();
          }
        }
      },
      handleReset() {
        if (confirm('Are you sure ? You will lose much of the information...')) {
          if (confirm('Please confirm again !')) {
            this.postReset();
          }
        }
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  h1, h2 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  .level-item {
    margin-right: 2.5rem !important;
  }
</style>